export default "__VITE_ASSET__2rQqRDwP__"